import actionCreatorFactory from "typescript-fsa";

import { UserExidRequestBody } from "../../core/api/requests/auth/exid/types";
import { LoginRequestBody } from "../../core/api/requests/auth/login/types";
import { UserMailChangeRequestBody } from "../../core/api/requests/auth/mail_change/types";
import { UserMailChangeSendRequestBody } from "../../core/api/requests/auth/mail_change_send/types";
import { UserMailCheckRequestBody } from "../../core/api/requests/auth/mail_check/types";
import { PasswordChangeRequestBody } from "../../core/api/requests/auth/password_change/types";
import { PasswordReminderRequestBody } from "../../core/api/requests/auth/password_reminder/types";
import { UserQuitRequestBody } from "../../core/api/requests/auth/quit/types";
import { UserRegisterRequestBody } from "../../core/api/requests/auth/register/types";
import { UserRegisterMailRequestBody } from "../../core/api/requests/auth/register_mail/types";
import { UserTemporaryRequestBody } from "../../core/api/requests/auth/temporary/types";
import { UserTemporaryMailRequestBody } from "../../core/api/requests/auth/temporary_mail/types";
import { UserEditRequestBody } from "../../core/api/requests/auth/user_edit/types";
import { CommonAsyncType } from "../../core/types";
import { User } from "./types";

const actionCreator = actionCreatorFactory("@@Auth");

export const authActions = {
  login: actionCreator.async<CommonAsyncType & LoginRequestBody, {}>("LOGIN"),
  setIsLoggedIn: actionCreator<boolean>("SET_IS_LOGGED_IN"),
  getUser: actionCreator.async<CommonAsyncType, User>("GET_USER"),
  logout: actionCreator.async<CommonAsyncType, {}>("LOGOUT"),
  sendRegistrationEmail: actionCreator.async<CommonAsyncType<string> & UserTemporaryRequestBody, {}>("SEND_REGISTRATION_EMAIL"),
  sendRegistrationEmailOnly: actionCreator.async<CommonAsyncType & UserTemporaryMailRequestBody, {}>("SEND_REGISTRATION_EMAIL_ONLY"),
  register: actionCreator.async<CommonAsyncType & UserRegisterRequestBody, {}>("REGISTER"),
  registerMail: actionCreator.async<CommonAsyncType & UserRegisterMailRequestBody, {}>("REGISTER_MAIL"),
  editUserInformation: actionCreator.async<CommonAsyncType & UserEditRequestBody, {}>("EDIT_USER_INFORMATION"),
  sendChangeEmail: actionCreator.async<CommonAsyncType & UserMailChangeSendRequestBody, {}>("SEND_CHANGE_EMAIL"),
  verifyEmailKey: actionCreator.async<CommonAsyncType & UserMailCheckRequestBody, {}>("VERIFY_CHANGE_EMAIL"),
  changeEmail: actionCreator.async<CommonAsyncType & UserMailChangeRequestBody, {}>("CHANGE_EMAIL"),
  forgetPassword: actionCreator.async<CommonAsyncType & PasswordReminderRequestBody, {}>("FORGET_PASSWORD"),
  resetPassword: actionCreator.async<CommonAsyncType & PasswordChangeRequestBody, {}>("RESET_PASSWORD"),
  deactivate: actionCreator.async<CommonAsyncType & UserQuitRequestBody, {}>("DEACTIVATE"),
  saveExternalId: actionCreator.async<CommonAsyncType & UserExidRequestBody, {}>("SAVE_EXTERNAL_ID"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
